import React from 'react';
import Students from './Students';
import ParentLayout from './ParentLayout';

export default function Layout(props) {
  return (
    <ParentLayout title="Student Impact">
      {function(params) {
        return (
          <>
            <Students params={params} />
          </>
        );
      }}
    </ParentLayout>
  );
}
